export default __webpack_public_path__ + "static/media/can-do1.6e6f1ee7.png";